module.exports = __webpack_public_path__ + "img/dropdown.8bd433f1.svg";